var map = {
	"./anteojos.svg": 9218,
	"./bikini.svg": 8277,
	"./blazer.svg": 1684,
	"./blusa.svg": 932,
	"./bolso.svg": 6765,
	"./botas.svg": 4096,
	"./botines.svg": 5899,
	"./bufanda.svg": 8621,
	"./camisa.svg": 7939,
	"./chaqueta.svg": 3864,
	"./cinturon.svg": 9375,
	"./collar.svg": 8988,
	"./falda.svg": 2315,
	"./jeans.svg": 9767,
	"./jockey.svg": 664,
	"./lentes.svg": 1736,
	"./pack.svg": 7075,
	"./pantalon.svg": 6957,
	"./panuelo.svg": 3011,
	"./pendientes.svg": 8744,
	"./polera.svg": 2504,
	"./sandalias.svg": 6816,
	"./top.svg": 9423,
	"./vestido.svg": 5506,
	"./zapatillas.svg": 8446,
	"./zapatos.svg": 8714
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5577;